import {
  schema,
  normalize
} from 'normalizr';
import omitBy from 'lodash.omitby'
import isNil from 'lodash.isnil'
import qatSchema from './qaSchema'

// Define quiz schema
const quizzesSchema = new schema.Entity('quizzes')
const quizzesListSchema = [quizzesSchema]

export function adaptQuizzesToStore({
  data
}) {
  const entries = normalize(data.results, quizzesListSchema)
  return {
    entries: entries.entities.quizzes,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results
  }
}

export function adaptQuizToApi(quiz = {}) {
  let payload = {
    id: quiz.id,
    time_cap_in_seconds: quiz.time_cap_in_seconds.toString(),
    min_score: quiz.min_score.toString(),
    max_attempts_per_user: quiz.max_attempts_per_user,
    shuffle_questions: quiz.shuffle_questions,
  };
  payload.metadata = {
    video_reference: quiz.video_reference,
    quiz_title: quiz.quiz_title,
    slug: quiz.slug,
    company: quiz.company.toLowerCase()
  }
  
  payload = omitBy(payload, isNil)

  payload.max_attempts_per_user = !quiz.max_attempts_per_user ? null : quiz.max_attempts_per_user
  return payload
}

export function adaptQuizToStore({ data }) {
  const entries = normalize(data, qatSchema)
  return {
    quiz: {
      id: data.id,
      time_cap_in_seconds: data.time_cap_in_seconds || 0,
      min_score: data.min_score || 0.70,
      max_attempts_per_user: data.max_attempts_per_user,
      number_of_questions: data.number_of_questions || 0,
      created: data.created,
      modified: data.modified,
      shuffle_questions: data.shuffle_questions,
      duration_in_seconds: data.duration_in_seconds,
      ...data.metadata,
    },
    questions: entries.entities.questions,
    answers: entries.entities.answers
  }
}

// QUESTIONS
export function adaptQuestionToApi(question = {}) {
  let payload = {
    content_md: question.content_md,
    shuffle_answers: question.shuffle_answers
  }

  return omitBy(payload, isNil)
}

export function adaptQuestionToStore({
  data
}) {
  return {
    id: data.id,
    content_md: data.content_md,
    shuffle_answers: data.shuffle_answers
  }
}

// ANSWERS

export function adaptAnswerToApi(answer = {}) {
  let payload = {
    id: answer.id,
    content_md: answer.content_md,
    is_correct: answer.is_correct,
    stick_to_bottom: answer.stick_to_bottom,
  }

  return omitBy(payload, isNil)
}

export function adaptAnswerToStore({
  data
}) {
  return {
    id: data.id,
    content_md: data.content_md,
    is_correct: data.is_correct,
    stick_to_bottom: data.stick_to_bottom,
  }
}
